export default __webpack_public_path__ + "static/media/desktop-background-img-min-dark.e411d0d6.png";